import progressiveLoadBackgroundImage from '../utilities/progressiveLoadBackgroundImage';

function init() {
  /*
  * Loads enhanced background image for the language page.
  */
  window.onload = function () {
    const languageElements = document.querySelectorAll('.language-bg-enhanced');
    if (languageElements.length > 0) {
      progressiveLoadBackgroundImage('language-bg-enhanced', () => {
        languageElements.forEach((element) => {
          element.removeAttribute('hidden');
        });
      });
    }
  };
}

export default {
  init() {
    // JavaScript to be fired on the language page
    init();
  },
  finalize() {
    // JavaScript to be fired on the language page, after the init JS
  },
};
